import { TextInput } from "@strapi/design-system";
import UploadFile from "../uploadFile";
import { useEffect, useState } from "react";
import { isStrEmpty } from "../../util/helper";
import { useTranslation } from "react-i18next";

const ReferralEmail = ({ data, setData }) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (!isStrEmpty(data?.file_name)) {
      setFileList([
        {
          uid: data?.file_id ?? data?.key,
          name: data?.file_name,
          status: "done",
        },
      ]);
    }
  }, [data]);

  useEffect(() => {}, [fileList]);

  const handleChangeAttachment = (resFile) => {
    setData({
      ...data,
      file_name: resFile?.name,
      file_id: resFile?.id,
    });
  };

  const handleRemoveAttachment = (resFile) => {
    setData({
      ...data,
      file_name: "",
      file_id: null,
      url: null,
    });
    setFileList([]);
  }

  return (
    <div>
      <TextInput
        label={t("str_referral_email")}
        name="name"
        value={t("str_recommendation_letter") + data.key}
        disabled={true}
      />
      <br />
      <span className="subnotes">{t("str_only_pdf")}</span>
      <br />
      <UploadFile
        fileMimeType={["application/pdf"]}
        fileTypeAllowNames="pdf"
        handleRemoveFile={handleRemoveAttachment}
        handleUploadSuccess={handleChangeAttachment}
        fileList={fileList}
        accept="application/pdf"
      />
    </div>
  );
};

export default ReferralEmail;
